export default String.raw`
.wishlist-container,
.wishlist-list {
    &__header {
      align-items: flex-start;
      flex-wrap: wrap;
  }
}

@media screen and (max-width: 400px) {
  .wishlist {
    &__table-container {
      .wishlist-item-container {
        .wishlist-products-images-container {
          .only-small-mobile-hide-element {
            display: none;
          }
          .only-small-mobile-show-element {
            display: flex;
          }
        }
      }
    }
  }
}

.wishlist {
  &__table-container {
    .wishlist-item-container {
      .wishlist-delete-button {
        visibility: visible;
      }
    }
  }
}

.row {
  .options.drop {
    .delete-product-from-wishlist-js {
      opacity: 1; 
    }
  }
}
`